import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./CategoriesSection.css";

export default function CategoriesSection() {
  return (
    <div>
      <Container className="section-p py-3">
        <div>
          <h2 className="descs">Popular Topics</h2>
        </div>
        <Row>
          <Col className="desc">
            <a href=""> Python</a>
          </Col>
          <Col className="desc">
            <a href="">Javascript</a>
          </Col>
          <Col className="desc">
            <a href="">React</a>
          </Col>
          <Col className="desc">
            <a href="">Unity</a>
          </Col>
          <Col className="desc">
            <a href="">C#</a>
          </Col>
        </Row>
        <Row>
          <Col className="desc">
            <a href="">Web Development</a>
          </Col>
          <Col className="desc">
            <a href="">Data Science</a>
          </Col>
          <Col className="desc">
            <a href="">Machine Learning</a>
          </Col>
          <Col className="desc">
            <a href="">Java</a>
          </Col>
          <Col className="desc">
            <a href="">CSS</a>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
